<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Saisie d'une demande client</strong>
          </div>
          <b-form id="fiche-form">
            <b-row>
              <b-col sm="6">
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> CONTACT</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-2">
                      <b-col sm="2">
                        <label for="civilite"><strong>Civilité  </strong></label>
                      </b-col>
                      <b-col>
                        <b-form-radio-group
                          id="radio-group-civilite"
                          v-model="contact_civ"
                          name="radio-civilite"
                          :class="{hasError: errors.contact_civ !== ''}"
                        >
                          <b-form-radio value="Mme">Madame</b-form-radio>
                          <b-form-radio value="M.">Monsieur</b-form-radio>
                        </b-form-radio-group>
                        <span class="field-error">{{ errors.contact_civ }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="2">
                        <label for="nom"><strong>Nom</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_nom" :class="{hasError: errors.contact_nom !== ''}"/>
                        <span class="field-error">{{ errors.contact_nom }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="2">
                        <label for="prenom"><strong>Prénom</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_prenom" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="2">
                        <label for="fonction"><strong>Fonction</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-select v-model="contact_fonction" :class="{hasError: errors.contact_fonction !== ''}">
                          <b-form-select-option value="null" disabled>-- Sélectionner --</b-form-select-option>
                          <b-form-select-option value="Employeur">Employeur</b-form-select-option>
                          <b-form-select-option value="Assuré">Assuré</b-form-select-option>
                          <b-form-select-option value="Bénéficiaire">Bénéficiaire</b-form-select-option>
                          <b-form-select-option value="Autre">Autre</b-form-select-option>
                        </b-form-select>
                        <span class="field-error">{{ errors.contact_fonction }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="2">
                        <label for="tel"><strong>N° Tél.</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_tel" :class="{hasError: errors.contact_tel !== ''}"/>
                        <span class="field-error">{{ errors.contact_tel }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="2">
                        <label for="precision"><strong>Précisions</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_precision" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="2">
                        <label for="email"><strong>Email</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_email" :class="{hasError: errors.contact_email !== ''}"/>
                        <span class="field-error">{{ errors.contact_email }}</span>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body style="margin-bottom:15px!important">
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> OBJET DE LA DEMANDE CLIENTE</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col>
                        <b-form-textarea rows="6" max-rows="6" id="demandeObjet" v-model="demande_objet" />
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body style="margin-top:25px;">
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> PRECISIONS SUR LE PRODUIT</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="gamme"><strong>Gamme</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-select ref="gammeSelect"
                              id="basicSelect"
                              :plain="true"
                              :options="produitOptions"
                              v-model="selectedProduit"
                              :class="{hasError: errors.selectedProduit !== ''}"
                        >
                          <template #first>
                            <b-form-select-option :value="null">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.selectedProduit }}</span>
                      </b-col>
                      <b-col sm="2">
                        <label for="produitPrecision"><strong>Obs.</strong></label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-input type="text" v-model="produit_precision" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="garantie"><strong>Garantie</strong></label>
                      </b-col>
                      <b-col sm="5">
                        <b-form-select ref="garantieSelect"
                              id="garantieSelect"
                              :plain="true"
                              :options="garantieOptions"
                              v-model="selectedGarantie"
                              :class="{hasError: errors.selectedGarantie !== ''}"
                        >
                          <template #first>
                            <b-form-select-option :value="null">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.selectedGarantie }}</span>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col sm="6">
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> EMPLOYEUR</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="raison_sociale"><strong>RS</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="structure_nom" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="siren"><strong>SIREN</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="structure_siren" :class="{hasError: errors.structure_siren !== ''}" />
                        <span class="field-error">{{ errors.structure_siren }}</span>
                      </b-col>
                      <b-col sm="2">
                        <label for="nic"><strong>NIC</strong></label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-input type="text" v-model="structure_nic" :class="{hasError: errors.structure_nic !== ''}" />
                        <span class="field-error">{{ errors.structure_nic }}</span>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> ASSURE / BENEFICIAIRE</b></span>
                  </div>
                  <b-card-body>

                    <b-row class="mb-3">
                      <b-col sm="11">
                        <auto-select
                            class="col-sm-11 d-inline-block"
                            id="nirList"
                            v-model="beneficiaire_nir"
                            :items="nirList"
                            :loading="loadingNir"
                            item-value="nir"
                            item-text="nom"
                            :placeholder="beneficiaire_nir ? '' : 'Saisir le NIR'"
                            disable-filtering-by-search
                            @search="onSearchNir"
                            v-on:keyup.enter="onEnterSelectNir('nirList')">
                            <template #no-data>
                              <span style="color: red">{{ noData ? "Aucun nir trouvé." : "Il faut au moins 5 caractères pour la recherche." }}</span>
                            </template>
                            <template slot="item" slot-scope="{ item: affiliation }">
                              <div style="display: flex;" @click="onClickSelectNir($event, affiliation, 'affiliation')">
                                <span class="item-name">
                                  <span style="color: black;"> {{ affiliation.nom }} {{ affiliation.prenom }} </span>
                                  <span style="color: #349ee2"> ({{ affiliation.nir }}) </span>
                                  <span style="color: #d9418b"> ({{ affiliation.siren ? affiliation.siren.siren : 'n.d' }})</span>
                                  <span style="color: #d9418b"> ({{ affiliation.famille_produit }})</span>
                                  <span style="color: #d7cb71"> ({{ affiliation.id_pp || 'n.d' }})</span>
                                </span>
                              </div>
                            </template>
                            <template slot="selection" slot-scope="{ item: affiliation }">
                              <div style="display: flex; align-items: center;">
                                <span class="item-name">
                                  <span style="color: black;"> {{ affiliation.nom }} {{ affiliation.prenom }} </span>
                                  <span style="color: #349ee2"> ({{ affiliation.nir }}) </span>
                                  <span style="color: #d9418b"> ({{ affiliation.siren ? affiliation.siren.siren : 'n.d' }})</span>
                                  <span style="color: #d9418b"> ({{ affiliation.famille_produit }})</span>
                                  <span style="color: #d7cb71"> ({{ affiliation.id_pp || 'n.d' }})</span>
                                </span>
                              </div>
                            </template>
                            <template v-if="loadingNir" #input-end>
                              <i class="fa fa-spinner fa-pulse fa-fw"></i>
                            </template>
                          </auto-select>
                          <i class="ml-2 clickable fa fa-undo" @click="raz()" v-b-tooltip.hover title="Effacer la séléction"></i>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="nom"><strong>Nom</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="beneficiaire_nom" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="prenom"><strong>Prénom</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="beneficiaire_prenom" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="num_ss"><strong>N° SS</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="beneficiaire_nir" />
                      </b-col>
                      <b-col sm="2">
                        <label for="cle"><strong>Clé</strong></label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-input type="text" v-model="beneficiaire_cle" />
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> VERIFICATIONS REALISEES PAR LE CONSEILLER</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col>
                        <b-form-textarea rows="6" max-rows="6" id="demandeVerification" v-model="demande_verification" />
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> CRITICITE ET PRISE EN CHARGE</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="criticite"><strong>Criticité</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-select v-model="criticite">
                          <b-form-select-option value="S">Standard</b-form-select-option>
                          <b-form-select-option value="R">Réclamation</b-form-select-option>
                          <b-form-select-option value="U">Urgent</b-form-select-option>
                        </b-form-select>
                      </b-col>
                      <b-col sm="2">
                        <label for="statut"><strong>Statut</strong></label>
                      </b-col>
                      <b-col sm="3">
                        <!-- <b-form-input type="text" v-model="statut" /> -->
                        <span class="field-error" style="margin-top:5px"><strong>Saisie en cours</strong></span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="domaine"><strong>Dest.</strong></label>
                      </b-col>
                      <b-col sm="5">
                        <b-form-select v-model="domaine" :options="domaineOptions">
                          <template v-slot:first>
                            <b-form-select-option :value="null">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.domaine }}</span>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card style="border:none!important">
                  <b-row class="mb-1">
                    <b-col sm="5">
                      <label for="notif"><strong>Envoi d'une notification au contact:  </strong></label><br>
                      <label><i>(sous réserve d'avoir renseigné l'Email)</i></label>
                    </b-col>
                    <b-col>
                      <b-form-radio-group
                        id="radio-group-notif"
                        v-model="notif"
                        name="radio-notif"
                      >
                        <b-form-radio value="false">Non</b-form-radio>
                        <b-form-radio value="true">Oui</b-form-radio>
                      </b-form-radio-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <div class="mt-1" slot="footer">
              <b-button type="button" @click="cancelForm" size="md" variant="secondary">
                <i class="fa fa-close"></i> Annuler
              </b-button>
              <b-button type="button" @click="submitForm('creation')" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
              <b-button type="button" @click="submitForm('brouillon')" size="md" class="pull-right mr-2" variant="warning">
                <i class="fa fa-sticky-note"></i> Brouillon
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {CoolSelect as AutoSelect} from 'vue-cool-select';
import {checkSIRET, checkSIREN, isEmpty} from "@/utils/fileHelper";

  export default {
    components: {
      AutoSelect,
    },
    name: 'ModalFiche',
    data() {
      return {
        contact_civ: '',
        contact_nom: '',
        contact_prenom: '',
        contact_fonction: null,
        contact_tel: '',
        contact_precision: '',
        contact_email: '',
        structure_nom: '',
        structure_siren: '',
        structure_nic: '',
        beneficiaire_nom: '',
        beneficiaire_prenom: '',
        beneficiaire_nir: '',
        beneficiaire_cle: '',
        demande_objet: '',
        demande_verification: '',
        produitOptions: [],
        selectedProduit: null,
        produit_precision: '',
        criticite: 'S',
        statut: '',
        domaine: null,
        domaineOptions: [],
        garantieOptions: ['IJ','Inval','Décès'],
        selectedGarantie: null,
        notif: false,
        nirList: [],
        loadingNir: false,
        noData: false,
        errors: {
          contact_civ: '',
          contact_nom: '',
          contact_fonction: '',
          contact_tel: '',
          contact_email: '',
          selectedProduit: '',
          selectedGarantie: '',
          domaine: '',
          structure_siren: '',
          structure_nic: ''
        }
      }
    },
    mounted() {

    },
    created() {
      this.getGammeProduits()
      this.getDomaines()
      this.clearForm()
    },
    methods: {
      getDomaines() {
        this.domaineOptions = [];
        let self = this;
        this.$axios
          .get("/espaceRelationClient/fiches/domaines")
          .then(response => {
            for (let domaine of response.data.domaines) {
              this.domaineOptions.push({text: domaine.libelle, value: domaine.id});
            }
          })
          .catch(function(error) {
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des produits. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              })
          })
      },
      getGammeProduits() {
        this.produitOptions = [];
        let self = this;
        this.$axios
          .get('/espaceRelationClient/fiche-niv2/produits')
          .then(response => {
            for (let row of response.data.produits) {
              this.produitOptions.push({text: row.libelle, value: row.id});
            }
          })
          .catch(function(error) {
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des produits. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              })
          })
      },
      submitForm(state) {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true)
          let self = this
          let dataPost = {}
          dataPost.id = 0
          dataPost.contact_civ = this.contact_civ
          dataPost.contact_nom = this.contact_nom
          dataPost.contact_prenom = this.contact_prenom
          dataPost.contact_fonction = this.contact_fonction
          dataPost.contact_tel = this.contact_tel
          dataPost.contact_precision = this.contact_precision
          dataPost.contact_email = this.contact_email
          dataPost.structure_nom = this.structure_nom
          dataPost.structure_siren = this.structure_siren
          dataPost.structure_nic = this.structure_nic
          dataPost.beneficiaire_nom = this.beneficiaire_nom
          dataPost.beneficiaire_prenom = this.beneficiaire_prenom
          dataPost.beneficiaire_nir = this.beneficiaire_nir + this.beneficiaire_cle
          dataPost.demande_objet = this.demande_objet
          dataPost.demande_verification = this.demande_verification
          dataPost.produit_id = this.selectedProduit
          dataPost.produit_precision = this.produit_precision
          dataPost.garantie = this.selectedGarantie
          dataPost.type = this.criticite
          dataPost.domaine_id = this.domaine
          dataPost.domaine_libelle = this.domaine.text
          dataPost.notif = this.notif
          dataPost.state = state
          this.$axios.post('/espaceRelationClient/fiche/store', dataPost)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              let fiche = response.data.fiche.fiche
              let criticiteSelected = fiche.type == 'S' ? 'Standard' : fiche.type == 'R' ? 'Réclamation' : fiche.type == 'U' ? 'Urgent' : ''
              let confirmation = '<span>Demande client enregistrée</span><br><span>Numéro de la demande : FC' + fiche.annee + '-' + fiche.numero_annee.toString().padStart(5,'0') +'</span><br><br><span>Criticité : ' + criticiteSelected + '</span><br>' + response.data.fiche.emailNotif
              console.log('confirmation', confirmation)

              this.$swal({ position: 'top', type: 'success', title: 'Création de la fiche avec succès', html: confirmation, showConfirmButton: false, timer: 5000 })
              this.$router.push('/espace-rc/fiche/show/' + fiche.id)
            })
            .catch(function (error) {
              console.log(error)
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'error', title: 'Attention !!', text: 'Un problème est survenu, merci de contacter l\'administration', showConfirmButton: false, timer: 5000 })
            })
        }
      },
      validateData() {
        this.clearErrors()
        let valid = true
        if (this.contact_civ == '') {
          this.errors.contact_civ = "Veuillez renseigner la civilité du contact"
          valid = false
        }
        if (this.contact_nom == '') {
          this.errors.contact_nom = "Le nom du contact est obligatoire"
          valid = false
        }
        if (this.contact_fonction == '') {
          this.errors.contact_fonction = "Veuillez renseigner la fonction du contact"
          valid = false
        }
        if (this.contact_tel !== '') {
          this.contact_tel = this.contact_tel.replaceAll(' ', '')
          if (this.contact_tel.length < 10 || this.contact_tel.length > 10) {
            this.errors.contact_tel = "Le numéro de téléphone doit contenir 10 chiffres"
            valid = false
          }
          if (/^\d+$/.test(this.contact_tel) === false) {
            this.errors.contact_tel = "Le numéro de téléphone ne doit contenir que des chiffres"
            valid = false
          }
        } else {
          this.errors.contact_tel = "Le numéro de téléphone du contact est obligatoire"
          valid = false
        }
        if (this.contact_email == '') {
          this.errors.contact_email = "L'adresse email du contact est obligatoire"
          valid = false
        }
        if (this.selectedProduit == null) {
          this.errors.selectedProduit = "Veuillez choisir une gamme produit"
          valid = false
        }
        if (this.domaine == null) {
          this.errors.domaine = "Veuillez choisir le destinataire"
          valid = false
        }
        if (!isEmpty(this.structure_siren)) {
          if(isEmpty(this.structure_nic)){
            if(!checkSIREN(this.structure_siren)){
              this.errors.structure_siren = "SIREN invalide"
              valid = false
            }
          }else{
            if(!checkSIREN(this.structure_siren)){
              this.errors.structure_siren = "SIREN invalide"
              valid = false
            }
            if(!checkSIRET(this.structure_siren + this.structure_nic)){
              this.errors.structure_nic = "NIC invalide"
              valid = false
            }
          }
        }

        return valid
      },
      clearForm() {

      },
      clearErrors() {
        this.errors.contact_civ = ''
        this.errors.contact_nom = ''
        this.errors.contact_fonction = ''
        this.errors.contact_tel = ''
        this.errors.contact_email = ''
        this.errors.selectedProduit = ''
        this.errors.domaine = ''
        this.errors.structure_siren = ''
        this.errors.structure_nic = ''
      },
      cancelForm() {
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: 'Voulez-vous vraiment annuler la création de la fiche ?',
            type: 'warning',
            reverseButtons: false,
            showCancelButton: true,
            cancelButtonColor: '#ff1744',
            confirmButtonText: 'Confirmer',
            cancelButtonText: 'Annuler',
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('/espace-rc/fiches-niveau2');
            }
          });
          
        // Etes-vous sûr de vouloir annuler la création de la fiche?
        // this.$bvModal.hide('modal-fiche')
        
      },
      async onSearchNir(search) {
        let self = this;
        const lettersLimit = 5;
        this.noData = false;
        if (search.length < lettersLimit) {
          this.loadingNir = false;
          return
        }
        if(search.length === 13){
          this.nirWithoutKey = search;
        }
        this.loadingNir = true;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(async () => {
          this.$axios
            .get(`/espaceGestion/nir/autocompleteRecherche?query=${search}`)
            .then(response => {
              // console.log('autocomplete data', response.data.data)
              this.loadingNir = false;
              this.nirList = response.data.data;
              this.noData = this.nirList.length === 0;
            })
            .catch(function (error) {
              // console.log(error);
              self.loadingNir = false;
              self.handleError(error);
            })
        }, 500)
      },
      raz() {
        this.beneficiaire_nom = '';
        this.beneficiaire_prenom = '';
        this.beneficiaire_nir = '';
        this.beneficiaire_cle = '';
        this.structure_nom = '';
        this.structure_siren = '';
        this.structure_nic = '';
        this.nirList = [];
        this.selectedProduit = null;
      },
      onClickSelectNir(event, item, typeInput) {
          this.beneficiaire_nom = item.nom;
          this.beneficiaire_prenom = item.prenom;
          this.beneficiaire_nir = this.getNirWithoutKey(item.nir);
          this.beneficiaire_cle = this.getNirKey(item.nir);
          this.structure_nom = item.siren.raison_sociale;
          this.structure_siren = item.siren.siren;
          this.structure_nic = !isEmpty(item.nic) ? item.nic : null
          this.selectedProduit = item.famille_produit_id;
      },
      onEnterSelectNir(typeList) {
        if (typeList == 'nirList') {
          for (let item of this.nirList) {
            if (this.beneficiaire_nir === item.id) {
              this.onClickSelectNir(null, item)
            }
          }
        }
      },
      getNirWithoutKey(nir) {
        let value = nir ? nir : '';
        if (value.length === 15) {
          value = nir.substring(0, 13);
        } else if (value.length === 14) {
          value += '0';
          value = value.substring(0, 13)
        }
        return value;
      },
      getNirKey(nir) {
        let value = nir ? nir : '';
        if (value.length === 15) {
          value = nir.substring(13);
        } else if (value.length === 14) {
          value += '0';
          value = value.substring(13)
        } else {
          value = '';
        }
        return value;
      },
      handleError(error) {
        // console.log(error)
        let text = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
        if (!isEmpty(error) && error.response && error.response.status === 403) {
          text = 'Vous n\'avez pas le droit de voir ce dossier';
        } else if (!isEmpty(error) && error.response && error.response.status === 424) {
          text = !isEmpty(error.response.data.infos) ? '<div class="text-left">' + error.response.data.message : error.response.data.message;
          if (!isEmpty(error.response.data.infos)) {
            text = text + '<ul>';
            for (let info of error.response.data.infos) {
              text = text + '<li>' + info + '</li>';
            }
            text = text + '</ul>';
          }
          text = !isEmpty(error.response.data.infos) ? text + '</div>' : text;
        }
        this.$store.commit("IS_LOADING", false);
        this.$swal({
          position: "top",
          type: "error",
          title: "Attention !!",
          html: text,
          showConfirmButton: false,
          timer: 0
        });
      },
    }
  }
</script>

<style scoped>

</style>
